import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { DICT } from "./i18n";

const LangContext = createContext({ lang: "en", dict: DICT.en, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("baq_lang") || "en";
    } catch {
      return "en";
    }
  });

  const setLang = (next) => {
    setLangState(next);
    try {
      localStorage.setItem("baq_lang", next);
    } catch {}
  };

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("lang", lang);
    html.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, dict: DICT[lang] || DICT.en, isRTL: lang === "ar" }),
    [lang]
  );
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
